export default "__VITE_ASSET__CU$wH3RT__"